import styled from 'styled-components'

export default styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  // border-bottom: 1px solid ${ ({ theme }) => theme.colors.almostWhite };
`
